import { EndPoint } from './endpoint.model';
export class ExpressionBlock {
public Condition = '';
public TextCondition = '';
public NestedBlocks: ExpressionBlock[] = [];
public Result: EndPoint;
public ElseBlocks: ExpressionBlock[] = [];
public NotRelavantDataElements = [];
public ValidationCondition = '';
public ArithmeticExpression = '';
public TextExpression: Object[];
public Level: number;
public Index: number;
public ParentID = '';
constructor() {
        this.Condition = '';
        this.TextCondition = '';
        this.ValidationCondition = '';
        this.NestedBlocks = [];
        this.ParentID = '';

        this.ElseBlocks = [];
        this.NotRelavantDataElements = [];
    }


}

function ExpressionBlock_tsickle_Closure_declarations() {
/** @type {?} */
ExpressionBlock.prototype.Condition;
/** @type {?} */
ExpressionBlock.prototype.TextCondition;
/** @type {?} */
ExpressionBlock.prototype.NestedBlocks;
/** @type {?} */
ExpressionBlock.prototype.Result;
/** @type {?} */
ExpressionBlock.prototype.ElseBlocks;
/** @type {?} */
ExpressionBlock.prototype.NotRelavantDataElements;
/** @type {?} */
ExpressionBlock.prototype.ValidationCondition;
/** @type {?} */
ExpressionBlock.prototype.ArithmeticExpression;
/** @type {?} */
ExpressionBlock.prototype.TextExpression;
/** @type {?} */
ExpressionBlock.prototype.Level;
/** @type {?} */
ExpressionBlock.prototype.Index;
/** @type {?} */
ExpressionBlock.prototype.ParentID;
}

